import React from 'react';
import { Box, Grid } from '@mui/material';
import { PageTitleSkeleton, MainWidgetSkeleton } from 'views/common/components';
import Skeleton from '@mui/material/Skeleton';

const VehicleModelDetailsSkeleton = () => (
  <Box>
    <PageTitleSkeleton />
    <Grid container spacing={4} pt={3}>
      <Grid item xs={12} md={7}>
        <Skeleton variant="rectangular" height={386} />
        <Grid container spacing={1} justifyContent="center" pt={2}>
          <Grid item xs={1}>
            <Skeleton variant="rectangular" height={45} />
          </Grid>
          <Grid item xs={1}>
            <Skeleton variant="rectangular" height={45} />
          </Grid>
          <Grid item xs={1}>
            <Skeleton variant="rectangular" height={45} />
          </Grid>
          <Grid item xs={1}>
            <Skeleton variant="rectangular" height={45} />
          </Grid>
          <Grid item xs={1}>
            <Skeleton variant="rectangular" height={45} />
          </Grid>
        </Grid>
        <Grid container spacing={1} justifyContent="center" pt={2}>
          <Grid item xs={6}>
            <Skeleton variant="rectangular" height={36} />
          </Grid>
        </Grid>
        <Box py={3}>
          <Skeleton variant="text" width="50%" />
          <Skeleton variant="text" width="100%" />
          <Skeleton variant="text" width="70%" />
          <Skeleton variant="text" width="90%" />
          <Skeleton variant="text" width="30%" />
        </Box>
        <Skeleton variant="text" height={45} width="90%" />
        <Skeleton variant="rectangular" height={300} width="80%" />
      </Grid>

      <Grid item xs={12} md={5}>
        <MainWidgetSkeleton vertical />
      </Grid>
    </Grid>
  </Box>
);
export { VehicleModelDetailsSkeleton };
